import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { PasswordResetSuccessPageComponent } from './password-reset-success-page.component';
import { DynamicIconDirectiveModule } from '@nai-libs/directives/dynamic-icon';

@NgModule({
  imports: [CommonModule, MatDialogModule, RouterModule, DynamicIconDirectiveModule],
  declarations: [PasswordResetSuccessPageComponent],
  exports: [PasswordResetSuccessPageComponent]
})
export class PasswordResetSuccessPageModule {}
